export default function getChargeCredits(
  amount: number,
) {
  let num = 0;
  if (amount < 10000) {
    num = 0;
  } else if (amount < 30000) {
    num = 1.5;
  } else if (amount < 50000) {
    num = 2;
  } else {
    num = 2.5;
  }
  return (amount * num) / 100;
}
